<template>
	<div class="en_foot">
		Sichuan Jiannanchun (Group) Co., Ltd.
	</div>
</template>

<script>
export default {
	data() {
		return {

		}
	}
}
</script>

<style lang="scss">
.en_foot {
    width: 100%;
	background-color: #c4a156;
	color: #fff;
	font-size: 20px;
	height: 140px;
	line-height: 140px;
}
@media screen and (min-width: 900px) {
	.en_foot {
		min-width: 900px;
	}
}
@media screen and (max-width: 900px) {
	.en_foot {
		font-size: 16px;
		height: 80px;
		line-height: 80px;
	}
}
</style>